import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const Heading = styled.h2`
  color: ${({ headingColor }) =>
    headingColor
      ? themeGet(`colors.${headingColor}`)
      : themeGet('colors.main-text')};
  margin-bottom: 1.25rem;
  text-align: ${({ contentAlignment }) => contentAlignment || 'left'};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledCtas = styled(Ctas)`
  &.center {
    margin: 2rem auto 0rem;
  }
`;
